/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropparticipationapp2Inputs */

const en_dropparticipationapp2 = /** @type {(inputs: Dropparticipationapp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App only`)
};

const de_dropparticipationapp2 = /** @type {(inputs: Dropparticipationapp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur in der App`)
};

/**
* | output |
* | --- |
* | "App only" |
*
* @param {Dropparticipationapp2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropparticipationapp2 = /** @type {((inputs?: Dropparticipationapp2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropparticipationapp2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropparticipationapp2(inputs)
	return de_dropparticipationapp2(inputs)
});
export { dropparticipationapp2 as "dropParticipationApp" }